module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }